import { render, staticRenderFns } from "./RegisterPhysiciansPage.vue?vue&type=template&id=16e13dfb"
import script from "./RegisterPhysiciansPage.vue?vue&type=script&lang=js"
export * from "./RegisterPhysiciansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports